import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';

// "Def" para no chocar con useEmailCategories() de useEmail.ts — ese devuelve
// valores DISTINCT de messages.category en uso con su count (para el filtro
// de la lista); este es la taxonomía editable por cuenta (name+color),
// antes CATEGORY_COLORS hardcodeado en EmailPage.tsx.
export interface EmailCategoryDef {
  id: number;
  name: string;
  color: string;
  createdAt: string;
}

export function useEmailCategoryDefs() {
  return useQuery<EmailCategoryDef[]>({
    queryKey: ['email-category-defs'],
    queryFn: () => api.get('/api/email-categories'),
    staleTime: 30_000,
  });
}

export function useCreateEmailCategoryDef() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: { name: string; color: string }) =>
      api.post<EmailCategoryDef>('/api/email-categories', data),
    onSuccess: () => { void qc.invalidateQueries({ queryKey: ['email-category-defs'] }); },
  });
}

export function useUpdateEmailCategoryDef() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, patch }: { id: number; patch: { name?: string; color?: string } }) =>
      api.patch<EmailCategoryDef>(`/api/email-categories/${id}`, patch),
    onSuccess: () => { void qc.invalidateQueries({ queryKey: ['email-category-defs'] }); },
  });
}

export function useDeleteEmailCategoryDef() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.delete(`/api/email-categories/${id}`),
    onSuccess: () => { void qc.invalidateQueries({ queryKey: ['email-category-defs'] }); },
  });
}
